import { AsyncPipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SiteSettingsService } from '@shared/services/site-settings.service';

@Component({
  selector: 'error-page',
  templateUrl: 'error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: true,
  imports: [TranslateModule, NgIf, AsyncPipe],
})
export class ErrorPageComponent {
  public siteSettings$ = this.siteSettings.fetchSiteSettings();

  constructor(
    private siteSettings: SiteSettingsService,
    private router: Router
  ) {}

  public navigate(route: string) {
    this.router.navigate([route]);
  }
}
